
import Button from '../../../components/base/Button';

export default function AboutSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-20 bg-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 mb-6">
              About ARK Construction Consultants Inc™
            </h2>
            <p className="text-lg text-slate-300 mb-6 leading-relaxed">
              ARK Construction Consultants Inc™ is a global construction and development consultancy specializing 
              <strong className="text-yellow-400"> AI-integrated smart homes, warehouses, ports, hospitals, and sustainable infrastructure</strong>. 
              We serve governments, private developers, and sovereign nations with complete design-build and advisory services.
            </p>
            <p className="text-lg text-slate-300 mb-8 leading-relaxed">
              Our expertise spans from individual smart homes to entire sustainable cities, combining cutting-edge AI technology 
              with proven construction methodologies to deliver infrastructure that's not just built for today, but engineered for tomorrow.
            </p>
            <Button onClick={scrollToContact} size="lg">
              <i className="ri-chat-3-line mr-2"></i>
              Request Consultation
            </Button>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/f7d07b50808ea6b3b82eaeacf2c6ef50.jpg"
                alt="ARK Construction Team"
                className="w-full h-96 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent"></div>
            </div>
            
            {/* Stats Overlay */}
            <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl p-6 shadow-xl">
              <div className="text-center">
                <div className="text-2xl font-bold text-slate-900">25+</div>
                <div className="text-sm text-slate-800">Years Experience</div>
              </div>
            </div>
            
            <div className="absolute -top-6 -left-6 bg-slate-900 border border-yellow-400/20 rounded-xl p-6 shadow-xl">
              <div className="text-center">
                <div className="text-2xl font-bold text-yellow-400">500+</div>
                <div className="text-sm text-slate-400">Projects Completed</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
